import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  contactIds: string[];
  onAddNewProperty: () => void;
  onPropertySelected: (propertyName: string) => void;
  onClose: () => void;
}

export default class ContactBulkActionsEditPropertySelectPropertyComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  get existingPropertyInfos(): ContactCustomPropertyInfo[] {
    return [
      this.contactsCache.groupsContactCustomPropertyInfo,
      ...this.contactsCache.customProperties.filter((x) => x.r !== true),
    ];
  }

  @action
  handleExistingPropertySelected(propertyInfo: ContactCustomPropertyInfo) {
    this.args.onPropertySelected(propertyInfo.l);
  }
}
